import React, { ReactElement } from "react";
// import { useDotFeature, useDotPocketFeature } from "../../features/hooks";
// import { useDeveloperMode, useShowDotOverlays } from "../../storage/hooks";
import { useAppSelector } from "../../store/hooks";
import DotController, { DOT_OVERLAY_COLOR } from "./DotController";
import Overlay from "../Overlay";
import { Attachment } from "../../injection/Attachment";
// import ShadowPortal from "../../ShadowPortal";

interface Props {
  dotNode: HTMLElement;
  attachment: Attachment;
  editorId: number;
}

function DotShadowContainer({
  editorId,
  dotNode,
  attachment,
}: Props): ReactElement {
  // const [devMode] = useDeveloperMode();
  // const [showDotOverlaysDebug] = useShowDotOverlays();
  // const [dotFeature] = useDotFeature(true);
  // const [dotPocketFeature] = useDotPocketFeature(true);
  const dotPocketFeature = true;
  const dotFeature = true;
  // const activeEditorId = useAppSelector((state) => state.editors.active);

  return (
    // <>
    //   {dotNode && (
    //     <ShadowPortal container={dotNode}>
    <div className="dot-container">
      <div className="font-raleway absolute left-0">
        <Overlay
          editorId={editorId}
          frozen
          // debug={(devMode && showDotOverlaysDebug && DOT_OVERLAY_COLOR) || ""}
          debug=""
          relativeElement={dotNode}
        >
          <DotController
            editorId={editorId}
            editorElement={attachment.editor}
            visible={dotFeature}
            interactive={dotPocketFeature}
          />
        </Overlay>
      </div>
    </div>
    //     </ShadowPortal>
    //   )}
    // </>
  );
}

export default DotShadowContainer;
